import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react";
import { api, setSessionToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch (_) {
            setUser(null);
            return null;
        }
    }, []);

    const logout = useCallback(async () => {
        try {
            await api.post("/auth/logout");
        } catch (_) {
            /* ignore */
        }
        setSessionToken(null);
        setUser(null);
    }, []);

    const startSignIn = useCallback(() => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/upload";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
            redirectUrl,
        )}`;
    }, []);

    useEffect(() => {
        // Skip /me check if returning from Emergent OAuth — AuthCallback
        // will exchange the session_id first.
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh().finally(() => setLoading(false));
    }, [refresh]);

    return (
        <AuthCtx.Provider
            value={{ user, setUser, loading, refresh, logout, startSignIn }}
        >
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthCtx);
    if (!ctx) throw new Error("useAuth must be inside <AuthProvider>");
    return ctx;
}
